var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { BILLING_ADDRESS_US, BILLING_SUBSCRIPTION_ID_BUSINESS, CARD_DETAILS, TAX_INFO_US, TEST_STRIPE_TOKEN, USER_NAME, } from '@lucidlink/sdk/test/data';
import { useLucidSdk } from '#context';
export const useBusinessMonthlyConversion = (workspaceId, { onError, onSettled, onSuccess } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const mutation = useMutation({
        mutationFn: async () => {
            const request = {
                billingSubscriptionId: BILLING_SUBSCRIPTION_ID_BUSINESS,
                tokenId: TEST_STRIPE_TOKEN,
                billingAddress: BILLING_ADDRESS_US,
                taxInfo: TAX_INFO_US,
                card: CARD_DETAILS,
                name: USER_NAME,
            };
            await lucidSdk
                .workspaceClient(workspaceId)
                .billing()
                .switchPlan(request);
        },
        onSuccess: () => {
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        onSettled: () => {
            if (typeof onSettled === 'function') {
                onSettled();
            }
        },
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useBusinessMonthlyConversion, "BQaElb9uT0+pguh7S8aDatOYRp8=", false, () => [useLucidSdk, useMutation]);
